import { useEffect } from "react";
import "./App.css";

const WORKBENCH_URL = "/kle/kb.html#/";

function App() {
  useEffect(() => {
    if (process.env.NODE_ENV !== "test" && typeof window !== "undefined") {
      window.location.replace(WORKBENCH_URL);
    }
  }, []);

  return (
    <main className="private-lab-redirect" aria-live="polite">
      <p>正在进入布局工作台...</p>
    </main>
  );
}

export default App;
